(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["search-form"] && !Shopify.designMode) return;
  try {
    const DEBOUNCE_MS = 250;
  const MIN_QUERY_LENGTH = 2;

  class PredictiveSearch extends HTMLElement {
    connectedCallback() {
      this.trigger = this.querySelector('[data-search-trigger]');
      this.panel = this.querySelector('[data-search-panel]');
      this.backdrop = this.querySelector('[data-search-backdrop]');
      this.input = this.querySelector('[data-search-input]');
      this.results = this.querySelector('[data-search-results]');
      this.closeButton = this.querySelector('[data-search-close]');

      this.suggestUrl = this.dataset.suggestUrl;
      this.sectionId = this.dataset.sectionId;
      this.timer = null;
      this.controller = null;
      this.selectedIndex = -1;

      this.trigger.addEventListener('click', () => this.toggle());
      this.closeButton.addEventListener('click', () => this.close());
      this.backdrop.addEventListener('click', () => this.close());
      this.input.addEventListener('input', () => this.onInput());
      this.addEventListener('keydown', (event) => this.onKeydown(event));
    }

    toggle() {
      if (this.panel.hidden) {
        this.open();
      } else {
        this.close();
      }
    }

    open() {
      this.panel.hidden = false;
      this.backdrop.hidden = false;
      this.trigger.setAttribute('aria-expanded', 'true');
      this.input.focus();
    }

    close() {
      this.panel.hidden = true;
      this.backdrop.hidden = true;
      this.trigger.setAttribute('aria-expanded', 'false');
      this.trigger.focus();
      this.selectedIndex = -1;
    }

    onInput() {
      clearTimeout(this.timer);
      const query = this.input.value.trim();

      if (query.length < MIN_QUERY_LENGTH) {
        this.results.innerHTML = '';
        return;
      }

      this.timer = setTimeout(() => this.search(query), DEBOUNCE_MS);
    }

    async search(query) {
      // Abandon any in-flight request so slow responses can't overwrite
      // results for a query the shopper has already moved past.
      if (this.controller) this.controller.abort();
      this.controller = new AbortController();

      const params = new URLSearchParams({
        q: query,
        section_id: this.sectionId,
        'resources[type]': 'product',
        'resources[limit]': '8',
      });

      this.results.setAttribute('aria-busy', 'true');

      try {
        const response = await fetch(`${this.suggestUrl}?${params}`, {
          signal: this.controller.signal,
        });
        if (!response.ok) throw new Error(response.statusText);

        this.results.innerHTML = await response.text();
        this.selectedIndex = -1;
      } catch (error) {
        if (error.name !== 'AbortError') {
          this.results.innerHTML = '';
        }
      } finally {
        this.results.setAttribute('aria-busy', 'false');
      }
    }

    onKeydown(event) {
      if (event.key === 'Escape') {
        this.close();
        return;
      }

      const items = Array.from(this.querySelectorAll('[data-search-result]'));
      if (items.length === 0) return;

      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        event.preventDefault();
        const step = event.key === 'ArrowDown' ? 1 : -1;
        this.selectedIndex = (this.selectedIndex + step + items.length) % items.length;

        items.forEach((item, index) => {
          item.setAttribute('aria-selected', index === this.selectedIndex);
        });
        items[this.selectedIndex].scrollIntoView({ block: 'nearest' });
      }

      if (event.key === 'Enter' && this.selectedIndex > -1) {
        event.preventDefault();
        items[this.selectedIndex].click();
      }
    }
  }

  if (!customElements.get('predictive-search')) {
    customElements.define('predictive-search', PredictiveSearch);
  }
  } catch(e) { console.error(e); }
})();

})();
